import React from 'react';
import { Spinner, Container, Row, Col } from "react-bootstrap"

export const LoadingView = (props: { title: string }) => {

	return (
		<Container>
			<Row className='justify-content-center text-center mt-5'>
				<Col xs='auto'><Spinner className='loading-screen-spinner' animation='border' /></Col>
			</Row>
			<Row className='justify-content-center text-center mt-4'>
				<p><b>{props.title}</b></p>
			</Row>
		</Container>
	);
}

export default LoadingView;